import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  @Input() text: string;
  @Input() selfClosed = false;

  staticAlertClosed = false;

  constructor() { }

  ngOnInit() {
    // Auto close alert timer
    if (this.selfClosed) {
      setTimeout(() => this.staticAlertClosed = true, 5000);
    }
  }

}
